import { createPersistedStore } from "./createPersistedStore";

type SettingsState = {
  defaultStore?: string;
  // max number of cycle-count items to download for offline access; device-local
  cycleCountItemLimit?: number;
  // Phone Code values (from em_employee_phone.phone_code) that are considered
  // text-message capable. The Text (SMS) action is only offered for employee
  // phone numbers whose PhoneCode is in this list. Device-local; empty = none.
  smsCapablePhoneCodes?: string[];
};

type SettingsAction = {
  setDefaultStore: (store?: string) => void;
  setCycleCountItemLimit: (limit?: number) => void;
  setSmsCapablePhoneCodes: (codes?: string[]) => void;
  reset: () => void;
};

const defaultState: SettingsState = {
  defaultStore: undefined,
  cycleCountItemLimit: undefined,
  smsCapablePhoneCodes: undefined,
};

export const useSettingsStore = createPersistedStore<SettingsState, SettingsAction>(
  defaultState,
  (set) => ({
    setDefaultStore(store) {
      set((state: any) => {
        state.defaultStore = store;
      });
    },
    setCycleCountItemLimit(limit) {
      set((state: any) => {
        state.cycleCountItemLimit = limit;
      });
    },
    setSmsCapablePhoneCodes(codes) {
      set((state: any) => {
        state.smsCapablePhoneCodes = codes;
      });
    },
    reset() {
      // Reset session settings (e.g. defaultStore is re-derived from the server
      // next time) but PRESERVE device-local preferences: cycleCountItemLimit
      // (tied to this device's storage) and smsCapablePhoneCodes (an admin/user
      // configuration for this device, not a session value).
      set((state: any) => {
        state.defaultStore = defaultState.defaultStore;
      });
    },
  }),
  "settings",
  (state) => ({
    defaultStore: state.defaultStore,
    cycleCountItemLimit: state.cycleCountItemLimit,
    smsCapablePhoneCodes: state.smsCapablePhoneCodes,
  })
);
